import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';

import { webPaths } from '../../routes/paths';
import Helmet from '../../components/Helmet';
import TuitionSelection from '../../components/TuitionSelection';
import { useGetMyProfileQuery } from '../../services/users';

export interface HomeProps extends MuiBoxProps {}

export const StudentTuition = ({ className }: HomeProps) => {
  const navigate = useNavigate();

  const {
    data: user,
    isLoading: loadingUser,
    isUninitialized: uninitialisedUser,
  } = useGetMyProfileQuery();

  useEffect(() => {
    if (!user && !loadingUser && !uninitialisedUser) {
      localStorage.removeItem('token');
      navigate(`${webPaths.root}`, { replace: true });
    }
  }, [user]);

  return (
    <>
      <Helmet />

      <TuitionSelection />
    </>
  );
};

StudentTuition.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

StudentTuition.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(StudentTuition)(
  ({ theme }) => `
`,
);
